/** Max health used for bar fill width and barrier positions along the health bar. */
export const BATTLE_HEALTH_MAX_VISUAL = 30;

/** Five barrier markers: destroyed when health ≤ threshold or threshold is in `barriersRemoved`. */
export const BATTLE_HEALTH_BARRIER_THRESHOLDS = [25, 20, 15, 10, 5];

/** Delay before HUD barrier sprites show dismantled (lets dismantle SFX play before the art updates). */
export const BARRIER_SPRITE_DISMANTLE_DELAY_MS = 1000;
